import React from 'react'
import HeroImage from '../assets/clearbrain_retargetingX01.png'
import PlaybookImg from '../assets/playbook.png'
import ConnectionsImg from '../assets/how-it-works/connections.png'
import PredictiveAudiencesImg from '../assets/how-it-works/audience-iso.png'
import DynamicPricingImg from '../assets/how-it-works/dynamic-pricing-iso.png'
import RetargetPredictedUsersImg from '../assets/how-it-works/retargeting-iso.png'
import InvisionLogoImg from '../assets/how-it-works/invision-logo.png'
import TheSkimmLogoImg from '../assets/how-it-works/the-skimm-logo.svg'
import OptimizelyLogoImg from '../assets/team-logos/optimizely-logo.svg'
import GoogleLogoImg from '../assets/team-logos/Google_2015_logo.svg'
import UberLogoImg from '../assets/team-logos/Uber_Logo_Black.png'
import DraftKingsLogoImg from '../assets/team-logos/DraftKings_logo.png'
import HarrisonMetalLogoImg from '../assets/investors/harrison-metal-logo.svg'
import PearLogoImg from '../assets/investors/pear-vc-logo.png'
import MenloVenturesLogoImg from '../assets/investors/menlo-ventures-logo.svg'
import YCombinatorLogoImg from '../assets/investors/ycombinator-logo.png'
import AtTopProp from '../components/at-top-prop.js'
import NavBar from '../components/navbar.js'
import Button from '../components/button.js'
import OnVisible from 'react-on-visible'
import AnimatedTagline from '../components/animated-tagline.js'

const ClearbrainAppSignupUrl = 'https://app.clearbrain.com/signup'
const ClearbrainJobsUrl = 'https://angel.co/clearbrain/jobs'
const PlaybookUrl = 'https://playbook.clearbrain.com'

export default class Index extends React.Component {
  render () {
    return (
      <div>
        <div className='hero is-primary is-bold'>
          <AtTopProp margin={100}>
            <NavBar actionUrl={ClearbrainAppSignupUrl} jobsUrl={ClearbrainJobsUrl} />
          </AtTopProp>
          <CenteredSection id='hero-body'>
            <div className='columns is-multiline'>
              <div className='has-text-left column is-three-fifths'>
                <h1 className='title is-size-2 is-spaced has-text-weight-semibold'>
                  <AnimatedTagline />
                </h1>
                <p className='subtitle is-size-5 is-marginless'>
                  Use AI to power your entire <span style={{whiteSpace: 'nowrap'}}>growth marketing funnel.</span>
                </p>
                <p className='subtitle is-size-5 is-marginless'>
                  Deliver ads, emails and notifications to the <span style={{whiteSpace: 'nowrap'}}>right person at the right time.</span>
                </p>
                <Button text='Get Started' href={ClearbrainAppSignupUrl} />
              </div>
              <div className='column is-two-fifths has-text-right'>
                <img src={HeroImage} />
              </div>
            </div>
          </CenteredSection>
        </div>
        <CenteredSection id='playbook'>
          <div className='columns is-centered'>
            <div className='column is-two-thirds'>
              <h2 className='title is-spaced'>A Tactical Guide to Growth Marketing</h2>
            </div>
          </div>
          <div className='columns is-centered'>
            <div className='column has-text-left is-one-half is-size-5'>
              <p className='explanation'>
                ClearBrain offers both the tools and strategy to scale your
                growth campaigns.
              </p>
              <p className='explanation'><a href={PlaybookUrl}>
                Download our free guide to growth marketing</a>, including
                15 step-by-step strategies on building customer segments,
                targeting them in ads, and monetizing your product funnel.
              </p>
              <Button text='Download the Playbook (free)' href={PlaybookUrl} />
            </div>
            <div className='column playbook is-one-third'>
              <a href={PlaybookUrl}>
                <figure className='image'>
                  <OnVisible className='on-visible-from-right'>
                    <img src={PlaybookImg} alt='playbook image' />
                  </OnVisible>
                </figure>
              </a>
            </div>
          </div>
        </CenteredSection>
        <CenteredSection id='how-it-works'>
          <div className='columns is-centered'>
            <div className='column is-two-thirds'>
              <h2 className='title is-spaced'>How ClearBrain Works</h2>
              <p className='subtitle'>
                ClearBrain enables Growth teams to use AI to automatically reach
                the right user at the right time. Get set up in minutes, without
                a single line of code.
              </p>
            </div>
          </div>
          <div className='columns is-centered'>
            <div className='column is-three-fourths is-centered'>
              <HowItWorks title='Connect Your Data. No Code Required.'
                src={ConnectionsImg} alt='connections' imgWidth='450px'>
                ClearBrain automatically connects to your email, analytics, or
                database platforms. We ingest your user traits and actions from
                analytics tools like Segment or mParticle, and transform the
                underlying data for predictive modeling. This requires no
                engineering, so you can get set up in minutes.
              </HowItWorks>
              <HowItWorks title='Point-And-Click Predictive Audiences.' reverse
                src={PredictiveAudiencesImg} alt='predictive audiences' imgWidth='450px'>
                ClearBrain learns from your users’ past actions who is most
                likely to perform a future action. Use a point-and-click
                interface to build propensity scores for conversion or churn in
                minutes. Create predictive lookalike audiences of your high vs.
                low value customers, by the click of a button.
              </HowItWorks>
              <HowItWorks title='Dynamic Pricing For Each User.'
                src={DynamicPricingImg} alt='dynamic pricing' imgWidth='450px'>
                Create dynamic offers relative to each user’s propensity to
                convert or churn. Automatically compute personalized ad bids in
                your Facebook ads, or proportional discounts in email campaigns.
                Increase revenue and reduce CPA by targeting the right user with
                the right price.
              </HowItWorks>
              <HowItWorks title='Retarget Predicted Users in Ads &amp; Emails.' reverse
                src={RetargetPredictedUsersImg} alt='retarget predictive users' imgWidth='450px'>
                Sync predictive audiences from ClearBrain into Facebook
                Lookalikes and Custom Audiences for reduced CPA. Increase open &amp;
                click rates in your emails by retargeting your highest
                propensity users. Power personalization campaigns to increase
                lift and retention in all your growth metrics.
              </HowItWorks>
            </div>
          </div>
        </CenteredSection>
        <CenteredSection id='ready-to-go'>
          <h3 className='title'>Ready To Go?</h3>
          <Button text='Get Started' href={ClearbrainAppSignupUrl} />
          <a id='testimonials' className='inactive-link' />
          <div className='columns is-centered'>
            <OnVisible className='column is-half testimonial on-visible-from-bottom'>
              <figure className='image'>
                <img src={InvisionLogoImg} alt='invision logo' />
              </figure>
              <p className='has-text-left'>ClearBrain has <span className='has-text-weight-bold'>transformed how we approach remarketing.</span> Several of our email and paid acquisition teams can now build predictive audience segments in minutes, consistently driving a <span className='has-text-weight-bold'>30% lift in CTR</span> and an overall <span className='has-text-weight-bold'>7% increase in product engagement.</span></p>
              <p className='has-text-left signature'>Steve Ebin - VP of Growth</p>
            </OnVisible>
            <OnVisible className='column is-half testimonial on-visible-from-bottom'>
              <figure className='image'>
                <img src={TheSkimmLogoImg} alt='the-skimm logo' />
              </figure>
              <p className='has-text-left'>We’ve been able to drive significant lift to our email marketing efforts with ClearBrain, <span className='has-text-weight-bold'>increasing upgrades by up to 43%</span> to our mobile subscription product. It’s made it really easy to predict any user conversion event, and <span className='has-text-weight-bold'>reach the right audience at the right time.</span></p>
              <p className='has-text-left signature'>Ryan Stuczynski - Head of Data &amp; Analytics</p>
            </OnVisible>
          </div>
        </CenteredSection>
        <CenteredSection id='meet-our-team'>
          <h2 className='title is-size-4 is-spaced'>Team</h2>
          <p className='subtitle' style={{fontSize: '0.97rem'}}>
            ClearBrain is led by a team of engineers with over 20 years
            experience at the intersection of machine learning and marketing
            automation. We’ve built and scaled predictive pipelines for Google
            Ads and Uber, led data engineering and data science at Optimizely,
            and built mission critical settlement systems at DraftKings.
          </p>
          <div className='columns is-multiline'>
            <LogoIcon href='https://www.optimizely.com/'
              src={OptimizelyLogoImg} alt='Optimizely'
              style={{width: '192px', height: '128px'}} />
            <LogoIcon href='https://www.google.com/'
              src={GoogleLogoImg} alt='Google'
              sizeClass='is-128x128' />
            <LogoIcon href='https://www.uber.com/'
              src={UberLogoImg} alt='Uber'
              sizeClass='is-128x128' />
            <LogoIcon href='http://www.draftkings.com/'
              src={DraftKingsLogoImg} alt='Draft Kings'
              sizeClass='is-128x128' />
          </div>
          <div className='has-text-centered'>
            <Button text='Join Us' href={ClearbrainJobsUrl} />
          </div>
        </CenteredSection>
        <CenteredSection id='investors'>
          <h2 className='title'>Our Investors</h2>
          <div className='columns is-multiline'>
            <LogoIcon href='https://www.harrisonmetal.com/'
              src={HarrisonMetalLogoImg} alt='Harrison Metal'
              sizeClass='is-64x64' />
            <LogoIcon href='https://www.pear.vc/'
              src={PearLogoImg} alt='Pear VC'
              sizeClass='is-96x96' />
            <LogoIcon href='https://www.menlovc.com/'
              src={MenloVenturesLogoImg} alt='Menlo Ventures'
              sizeClass='is-64x64' />
            <LogoIcon href='http://www.ycombinator.com/'
              src={YCombinatorLogoImg} alt='Y Combinator'
              sizeClass='is-64x64' />
          </div>
        </CenteredSection>
        <CenteredSection style={{backgroundColor: '#008bdd'}}>
          <h3 className='title has-text-white'>Get started with ClearBrain today.</h3>
          <Button text='Get Started' href={ClearbrainAppSignupUrl} />
        </CenteredSection>
      </div>
    )
  }
}

class CenteredSection extends React.Component {
  render () {
    return (
      <section style={this.props.style}
        className={`section ${this.props.id} columns is-centered has-text-centered`}>
        <a id={this.props.id} className='inactive-link' />
        <div className='container column is-centered'>
          {this.props.children}
        </div>
      </section>
    )
  }
}

class HowItWorks extends React.Component {
  render () {
    return (
      <div className='columns is-centered is-vcentered' style={{flexDirection: this.props.reverse ? 'row-reverse' : 'row'}}>
        <div className='column has-text-left'>
          <h5 className='title'>{this.props.title}</h5>
          <p className='explanation'>{this.props.children}</p>
        </div>
        <div className='column is-vcentered'>
          <figure className='image'>
            <OnVisible className={`on-visible-from-${this.props.reverse ? 'left' : 'right'}`}>
              <img src={this.props.src} alt={this.props.alt} style={{width: this.props.imgWidth}} />
            </OnVisible>
          </figure>
        </div>
      </div>
    )
  }
}

class LogoIcon extends React.Component {
  render () {
    return (
      <a className='column' href={this.props.href} target='_blank' rel='noopener'>
        <figure className={`logo image is-16x9 ${this.props.sizeClass}`} style={this.props.style}>
          <img src={this.props.src} alt={this.props.alt} title={this.props.alt} />
        </figure>
      </a>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/index.js